import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Switch } from "~/foundation/components/Switch";
import { Text } from "~/foundation/components/Text";

const FLAGS = [
  {
    id: "comments",
    label: "Comments",
    description: "Threaded discussion alongside a document.",
    value: true,
  },
  {
    id: "templates",
    label: "Templates",
    description: "Offer starting points when creating a document.",
    value: true,
  },
  {
    id: "ai-assist",
    label: "AI assistance",
    description: "Summarise and rewrite from inside the editor.",
    value: false,
  },
  {
    id: "public-profiles",
    label: "Public profiles",
    description: "Members can publish a profile page at /u/<name>.",
    value: false,
  },
];

export function Features() {
  const { t } = useTranslation();
  const [flags, setFlags] = useState(FLAGS);

  return (
    <div className="flex flex-col gap-3">
      <Text variant="small">{t("Optional capabilities, on for the whole workspace.")}</Text>

      <div className="rounded-md border border-divider px-4">
        {flags.map((flag, index) => (
          <div key={flag.id} className={index > 0 ? "border-t border-divider" : undefined}>
            <Switch
              checked={flag.value}
              onCheckedChange={(value) =>
                setFlags((current) => current.map((f) => (f.id === flag.id ? { ...f, value } : f)))
              }
              label={t(flag.label)}
              description={t(flag.description)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
